<template>
    <ul class="progress-indicator"> 
        <template v-for="(item, index) in items" :key="item">
            <li :class="[{'completed': isCompleted(index)},{'active': isActive(index)}]"> 
                <span class="bubble"></span> 
                step {{index+1}}.{{item.label}} 
                    <template v-if="index==0">
                    <br/> {{creator}}({{format_date_yyyyMMddHHmm(creatorTime)}})
                    </template>
                    <template v-else-if="index==1">
                    <br/> {{sourcer}}
                    <template v-if="sourcerTime">
                        ({{format_date_yyyyMMddHHmm(sourcerTime)}})
                    </template>
                    
                    </template>
                    <template v-else-if="index==2">
                        <template  v-for="(item1, index1) in addMembers" :key="item1">
                            <br/> {{item1}}
                            <template v-if="addMembersTime[index1]">
                                ({{format_date_yyyyMMddHHmm(addMembersTime[index1])}})
                            </template>
                            
                        </template>
                   </template>
                    <template v-else-if="index==3">
                        <br/> {{manager}}
                        <template v-if="managerTime">
                            ({{format_date_yyyyMMddHHmm(managerTime)}})
                        </template>
                   
                    </template>
            </li> 
        </template>
        </ul>
           
           
            
</template>  
<script>


export default {
    props: ["stepId","creator","sourcer","manager","addMember","creatorTime","sourcerTime","managerTime","addMemberTime"],
    components: {

    },
    data() {
        return {
            items: [
                { label: '申請', to: '', class: 'green_item', style: 'font-weight:bolder;font-size:large' },
                { label: 'Sourcer', to: '', class: 'white_item', style: 'font-weight:bolder;font-size:large' },
                { label: '會簽', to: '', class: 'white_item', style: 'font-weight:bolder;font-size:large' },
                { label: '主管', to: '', class: 'white_item', style: 'font-weight:bolder;font-size:large' }
            ],
            addMembers:[],
            addMembersTime:[]
        }
    },
    Service: null,
    EFormService: null,
    created() {
        this.ShowStep();
       
    },
    watch: {
        stepId: function () {
              // watch it
             // console.log("Prop changed: ", newVal, " | was: ", oldVal);
              this.ShowStep();
            },
            addMember: function () {
              // watch it
              //console.log("Prop changed: ", newVal, " | was: ", oldVal);
              this.addMembers=this.addMember.split(",");
            },
            addMemberTime: function () {
              // watch it
              //console.log("Prop changed: ", newVal, " | was: ", oldVal);
              this.addMembersTime=this.addMemberTime.split(",");
            },
          },


    computed: {
      
    },
   methods: {
    isCompleted(index) {
             return this.stepId>index;
        },
    isActive(index) {
             return this.stepId==index;
        },
         onWizardComplete(){

    },
  
        
    onWizardChange(prevIndex, nextIndex){
      //console.log(prevIndex)
      //console.log(nextIndex)
      this.pageIndex=nextIndex;
 
    },
            ShowStep() {
                //sourcer
                if (this.stepId == 1) {
                    this.items[1].class = 'yellow_item'
                    this.items[2].class = 'white_item'
                    this.items[3].class = 'white_item'
                }
                //會簽            
                if (this.stepId == 2) {
                    this.items[1].class = 'green_item'
                    this.items[2].class = 'yellow_item'
                    this.items[3].class = 'white_item'
                }
                //主管
                if (this.stepId == 3) {
                    this.items[1].class = 'green_item'
                    this.items[2].class = 'green_item'
                    this.items[3].class = 'yellow_item'
                }
            },
        }
    }
</script>
  

<style scoped> 

#progressbar {  
    margin-bottom: 30px;  
    overflow: hidden;  
    color: lightgrey  
}  
#progressbar .active {  
    color: #2F8D46  
}  
#progressbar li {  
    list-style-type: none;  
    font-size: 15px;  
    width: 25%;  
    float: left;  
    position: relative;  
    font-weight: 400  
}  
#progressbar #step1:before {  
    content: "1"  
}  
#progressbar #step2:before {  
    content: "2"  
}  
#progressbar #step3:before {  
    content: "3"  
}  
#progressbar #step4:before {  
    content: "4"  
}  
#progressbar li:before {  
    width: 50px;  
    height: 50px;  
    line-height: 45px;  
    display: block;  
    font-size: 20px;  
    color: #ffffff;  
    background: lightgray;  
    border-radius: 50%;  
    margin: 0 auto 10px auto;  
    padding: 2px  
}  
#progressbar li:after {  
    content: '';  
    width: 100%;  
    height: 2px;  
    background: lightgray;  
    position: absolute;  
    left: 0;  
    top: 25px;  
    z-index: -1  
}  
#progressbar li.active:before  
{  
    background: #2F8D46  
}  
#progressbar li.active:after {  
    background: #2F8D46  
}  
#progressbar li.active:after {  
    background: #2F8D46  
}  
</style>